import { FC, ReactNode } from 'react'
import Active from '@components/Items/Filters/Active'
import Filters from '@components/Items/Filters'
import useFilter from '@components/Items/utils/hooks/useFilter'
import Pagination from '@components/PaginationLayout/Pagination'
import SelectPage from '@components/PaginationLayout/SelectPage'
import getPagination from '@utilities/functions/getPagination'

type PropTypes = {
  children: ReactNode
  totalCount: number
}

const Desktop: FC<PropTypes> = ({ children, totalCount }) => {
  const { itemSearchQuery, pageIdQuery, updateQuery } = useFilter()
  const pageChange = (pageId: number) => {
    if (pageId === Number(pageIdQuery) || (!pageIdQuery && pageId === 1)) return
    updateQuery('pageId', pageId)
  }
  const { current_page, total_pages } = getPagination(
    totalCount,
    Number(pageIdQuery) || 1
  )
  return (
    <>
      <div className="flex justify-between gap-4 pt-8 ">
        <div className="w-full flex items-center gap-4 mb-4">
          <h1 className="font-bold text-4xl uppercase max-w-[70%]">
            {itemSearchQuery || ''}
          </h1>
          <h2 className="font-semibold text-xl whitespace-nowrap">
            {(totalCount || 0).toLocaleString('en-US')}
            {totalCount === 10000 ? '+' : ''} RESULTS
          </h2>
        </div>
        {total_pages ? (
          <div className={'my-auto'}>
            <Pagination
              page={current_page}
              totalPages={total_pages}
              pageChange={pageChange}
            />
          </div>
        ) : (
          <div />
        )}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-8">
        <Filters />
        <div className="grid-cols-1 md:col-span-2 lg:col-span-3 2xl:col-span-4">
          <div className="w-full mb-4">
            <Active />
          </div>
          {children}
        </div>
      </div>
    </>
  )
}

export default Desktop
